export default "__VITE_ASSET__D2InoXnC__"